import React from 'react';
import { Icon } from 'semantic-ui-react';

import Accounts from './Accounts';

export default {
  label: 'Accounts',
  url: '/o/accounts',
  icon: <Icon name="user" />,
  content: Accounts,
};
